import { CompositeSessionInfoSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { anyItemIsEmbeddedDatasource, anyItemIsUnpublishedWorkbook } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { Messages } from '../../codegen/Localize';
import { ISetPermissionsAction } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { setContentPermissions } from './SetContentPermissionsActions';

export const SetPermissionsAction: IEntityAction<IContentInfo, ISetPermissionsAction> = {
  name: EntityActionNames.Permissions,
  translateName: Messages.permissions_action,
  isVisible: (targetItems: IContentInfo[]) => {
    if (anyItemIsUnpublishedWorkbook(targetItems)) {
      return false;
    }

    return !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: ISetPermissionsAction, targetItems: IContentInfo[], state: AppState) => {
    // for multiple contents, setPermission action is always available to help with performance, and the backend does a final check to verify the user
    // can edit permissions for all selected items only after the action has been clicked (but before opening permission dialog).
    // However if limited user visibility is enforced, the user definitely cannot edit permissions so the action should always be disabled no matter
    // what content(s) are selected.
    if (CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state)) {
      return false;
    }

    // Currently for collections, SetPermissionsAction is enabled only for owner and admin, which can be checked using session info.
    // TODO: Remove with STORY 1202263, once the changePermissions capability gets added to collections and
    // availableActions can be fetched through getCollectionActions.
    if (targetItems.length === 1 && targetItems[0].contentType === 'collection') {
      return CompositeSessionInfoSelectors.currentUserIsAdminOrOwnerSelector(targetItems[0].owner)(state);
    } else {
      return !!(availableActions && availableActions.setPermissions);
    }
  },
  createReduxAction: (targetItems: IContentInfo[]) => setContentPermissions(targetItems)
};
